export const mockTypeCategoriesMap = {
  primitive: 'Primitive',
  address: 'Address',
  person: 'Person',
  internet: 'Internet',
  string: 'String',
  lorem: 'Lorem'
};

export const mockTypesMap = {
  number: { label: 'Number', category: 'primitive', dataType: 'number' },
  string: { label: 'String', category: 'primitive', dataType: 'string' },
  boolean: { label: 'Boolean', category: 'primitive', dataType: 'boolean' },
  date: { label: 'Date', category: 'primitive', dataType: 'date' },
  array: { label: 'Array', category: 'primitive', dataType: 'array' },
  object: { label: 'Object', category: 'primitive', dataType: 'object' },
  alphanumeric: { label: 'Alphanumeric', category: 'string', dataType: 'string', args: { length: { min: 5, max: 10 } } },
  word: { label: 'Word (Lorem)', category: 'lorem', dataType: 'string' },
  sentence: { label: 'Sentence (Lorem)', category: 'lorem', dataType: 'string' },
  address: { label: 'Full Address', category: 'address', dataType: 'string' },
  cityName: { label: 'City Name', category: 'address', dataType: 'string' },
  country: { label: 'Country', category: 'address', dataType: 'string' },
  countryCode: { label: 'Country Code', category: 'address', dataType: 'string' },
  county: { label: 'County', category: 'address', dataType: 'string' },
  latitude: { label: 'Latitude', category: 'address', dataType: 'number' },
  longitude: { label: 'Longitude', category: 'address', dataType: 'number' },
  secondaryAddress: { label: 'Secondary Address', category: 'address', dataType: 'string' },
  state: { label: 'State', category: 'address', dataType: 'string' },
  stateAbbr: { label: 'State Abbreviation', category: 'address', dataType: 'string' },
  street: { label: 'Street', category: 'address', dataType: 'string' },
  streetAddress: { label: 'Street Address', category: 'address', dataType: 'string' },
  streetName: { label: 'Street Name', category: 'address', dataType: 'string' },
  streetPrefix: { label: 'Street Prefix', category: 'address', dataType: 'string' },
  streetSuffix: { label: 'Street Suffix', category: 'address', dataType: 'string' },
  timeZone: { label: 'Time Zone', category: 'address', dataType: 'string' },
  zipCode: { label: 'Zip Code', category: 'address', dataType: 'string' },
  phoneNumber: { label: 'Phone Number', category: 'person', dataType: 'string' },
  firstName: { label: 'First Name', category: 'person', dataType: 'string' },
  lastName: { label: 'Last Name', category: 'person', dataType: 'string' },
  middleName: { label: 'Middle Name', category: 'person', dataType: 'string' },
  fullName: { label: 'Full Name', category: 'person', dataType: 'string' },
  gender: { label: 'Gender', category: 'person', dataType: 'string' },
  jobTitle: { label: 'Job Title', category: 'person', dataType: 'string' },
  prefix: { label: 'Name Prefix', category: 'person', dataType: 'string' },
  sex: { label: 'Sex', category: 'person', dataType: 'string' },
  suffix: { label: 'Name Suffix', category: 'person', dataType: 'string' },
  avatar: { label: 'Avatar', category: 'internet', dataType: 'string' },
  color: { label: 'Color', category: 'internet', dataType: 'string' },
  domainName: { label: 'Domain Name', category: 'internet', dataType: 'string' },
  domainSuffix: { label: 'Domain Suffix', category: 'internet', dataType: 'string' },
  domainWord: { label: 'Domain Word', category: 'internet', dataType: 'string' },
  email: { label: 'Email', category: 'internet', dataType: 'string' },
  ipv4: { label: 'IPv4', category: 'internet', dataType: 'string' },
  ipv6: { label: 'IPv6', category: 'internet', dataType: 'string' },
  password: { label: 'Password', category: 'internet', dataType: 'string' },
  protocol: { label: 'Protocol', category: 'internet', dataType: 'string' },
  url: { label: 'URL', category: 'internet', dataType: 'string' },
  userName: { label: 'Username', category: 'internet', dataType: 'string' }
};
